import { useQuery } from 'react-query';

import { LibraryPanelTemplate } from '@mpm-druid/types';
import api, { QueryConfig } from '@shared/api';
import { useActiveWorkspace } from '@shared/hooks';

type GetPanelTemplatesResponse = {
  templates: {
    id: string;
    name: string;
    owner: string;
    createdAt: string;
  }[];
};

async function getPanelLibraryTemplates({
  signal,
  workspaceId
}: {
  signal?: AbortSignal;
  workspaceId: string;
}) {
  const { data } = await api.get<GetPanelTemplatesResponse>(
    `code-panels/mpm/templates`,
    { params: { workspaceId }, signal }
  );

  return data.templates.map(template => ({
    created_at: template.createdAt,
    created_by: template.owner,
    id: template.id,
    name: template.name,
    updated_at: template.createdAt
  }));
}

export function usePanelLibraryTemplates(
  _params: void,
  config?: QueryConfig<LibraryPanelTemplate[]>
) {
  const activeWorkspace = useActiveWorkspace();
  const workspaceId = activeWorkspace.id;

  return useQuery(
    ['panel-library-templates', { workspaceId }],
    context => {
      return getPanelLibraryTemplates({
        workspaceId,
        signal: context.signal
      });
    },
    {
      retry: false,
      ...config,
      enabled: (config?.enabled ?? true) && !!workspaceId
    }
  );
}
